export type ITypeNature = 'pf' | 'pj';

export type IArrayString = Array<string>;

export const enum TYPE_PERMISSION {
  PERFORMANCE = 'performance',
  PRODUCTION = 'production',
  REPORTS = 'reports',
  PURSCHASES = 'purchases',
  FINANCE = 'finance',
  COMERCIAL = 'commercial',
  EMPLOYEES = 'employees',
}
export type IListPermissions = Record<TYPE_PERMISSION, IArrayString>;

export interface IGetUsersResponse {
  id: number | string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;

  name: string;
  cpfCnpj: string;
  cellphone: string;
  email: string;
  function: string;
  nature: ITypeNature;
  active: boolean;

  last_domain: string; //TODO:not used
  lastLogin: string;
  firstAccess: boolean;
  permissions: IListPermissions;
}

export interface IPayloadPostNewuser {
  name: string;
  cpfCnpj: string;
  cellphone: string;
  email: string;
  function: string;
  nature: ITypeNature;
  permissions: IListPermissions;
}
export interface IPostNewUserResponse {
  message: '';
}

export interface IPayloadEditUser extends IPayloadPostNewuser {
  active: boolean;
}
